import { $gettext } from '@/config/gettext'

const primary = [
  {
    label: $gettext('Home'),
    routeName: 'Private/Home'
  },
  {
    label: $gettext('Packages'),
    routeName: 'Private/Package'
  },
  {
    label: $gettext('Hotels'),
    routeName: 'Private/Hotel'
  },
  {
    label: $gettext('Rent a Car'),
    routeName: 'Private/CarHire'
  },
  {
    label: $gettext('Transfer'),
    routeName: 'Private/Transfer'
  },
  {
    label: $gettext('Reservations'),
    routeName: 'Private/Bookings'
  }
]

const secondary = [
  {
    label: $gettext('log out'),
    routeName: 'Private/Logout',
    icon: 'power'
  },
  {
    label: $gettext('Account'),
    routeName: 'Private/Account',
    icon: 'person-fill'
  }
]

export {
  primary,
  secondary
}
